import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

export default function ProtectedRoute() {
  const { isAuthenticated } = useAuthStore()
  const location = useLocation()

  if (!isAuthenticated) {
    // Host → prezentační stránka „Odemkni víc" (proč se registrovat), ne holé přihlášení.
    // Cílovou cestu předáme přes ?next=, ať se po přihlášení dá vrátit.
    return <Navigate to={`/odemknout?next=${encodeURIComponent(location.pathname)}`} replace />
  }

  return <Outlet />
}
